// utils.js
export function isValidUrl(url) {
  return /^https?:\/\/[^\s]+$/.test(url);
}

export const formatMessageContent = (content) => {
  if (!content) return '';

  const lines = content.split('\n');
  const filteredLines = lines.filter((line) => line.trim().length > 0);
  const listItems = filteredLines.map((line, index) => {
    const firstColonIndex = line.indexOf(':');
    if (firstColonIndex !== -1) {
      const prefix = line.slice(0, firstColonIndex + 1);
      const rest = line.slice(firstColonIndex + 1);
      return (
          <li key={index}>
            <strong>{prefix}</strong>
            {rest}
          </li>
      );
    }
    return <li key={index}>{line}</li>;
  });

  return <ol>{listItems}</ol>;
};
